import { render, staticRenderFns } from "./warnWindow.vue?vue&type=template&id=0b73a511&scoped=true&"
import script from "./warnWindow.vue?vue&type=script&lang=js&"
export * from "./warnWindow.vue?vue&type=script&lang=js&"
import style0 from "./warnWindow.vue?vue&type=style&index=0&id=0b73a511&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73a511",
  null
  
)

export default component.exports